import { AddonsUserArrivalPage } from './../../addons/addons-user-arrival/addons-user-arrival';
import { Component } from '@angular/core';
import { Globals } from '../../../globals';
import { ToastController, NavController, NavParams, LoadingController } from 'ionic-angular';

/**
 * Generated class for the component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'start-screens',
  templateUrl: 'start-screens.html'
})
export class StartScreensPage {

  constructor(public globals: Globals,
    public toastCtrl: ToastController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController) {
  }

  getInfo() {
    this.navCtrl.push(AddonsUserArrivalPage);
  }

  openDishes() {
    this.globals.tour = 'dish';
    this.globals.tour_step_user = -1;
    this.globals.GAtrackView('Tour', 'Tour - Dish - Start ', this.globals.restaurant.email, 'Start', 'Tour dish start', 'Tour', 'Dish');
  }

  openMenus() {
    this.globals.tour = 'menu';
    this.globals.tour_step_user = -1;
    this.globals.GAtrackView('Tour', 'Tour - Menu - Start ', this.globals.restaurant.email, 'Start', 'Tour menu start', 'Tour', 'Menu');
  }

  openTPV() {
    this.globals.tour = 'sale';
    this.globals.tour_step_user = -1;
    this.globals.GAtrackView('Tour', 'Tour - Sale - Start ', this.globals.restaurant.email, 'Start', 'Tour sale start', 'Tour', 'Sale');
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/start-screens/start-screens.ts